import CustomTreeView from '../../../../../../components/Tree/CustomTreeView';
import { CustomCheckbox } from '../../../../../../components/CustomCheckbox';
import CustomDaySelector from '../../../../../../components/CustomDaySelector';
import CustomTimePicker from '../../../../../../components/CustomTimePicker';
import {
    ArrowRightIcon,
    PlusIconsOptions,
    UpdateIconsOptions
} from '../../../../../../components/buttons/IconButtons';
import React, { useLayoutEffect, useRef, useState } from 'react';
import Customized from '../../Functionality/Customized';
import { useTranslation } from 'react-i18next';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import CustomizedItem from './CustomizedItem';
import ButtonActionsCard from '../../../../../../components/buttons/ButtonActionsCard';
import CustomWorkShifts from '../Modals/CustomWorkShifts';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const CustomizedSchedule = ({ customizedList, setCustomizedList, autoHeight=true }) => {
    const [customizedListAux, setCustomizedListAux] = useState([]);
    const elementRef = useRef(null);
    const activeScheduleRef = useRef(null);
    const zonesCardRef = useRef(null);
    const [showModal, setShowModal] = useState(false);

    const { t } = useTranslation();

    const {
        item,
        setItem,
        handleCheck,
        selectAllDays,
        handleAllTime,
        handleCLick,
        handleRemoveAccess,
        handleAdded,
        setChecked,
        setDayArray,
        emptyFields,
        isValidTo
    } = Customized({
        customizedList: customizedListAux,
        setCustomizedList: setCustomizedListAux,
        show: true
    });

    useLayoutEffect(() => {
        if(!autoHeight) return;
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 90;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    useLayoutEffect(() => {
        const syncHeight = () => {
            if (!activeScheduleRef.current || !zonesCardRef.current) return;
            zonesCardRef.current.style.height = `${activeScheduleRef.current.offsetHeight}px`;
        };
        syncHeight();
        window.addEventListener('resize', syncHeight);
        return () => window.removeEventListener('resize', syncHeight);
    }, [item]);

    return (
        <>
            <div className={`${autoHeight ? 'panelTables-container' : ''} custom-scrollbar`} ref={elementRef}>
                <div className="row g-3">
                    {/* ZONES */}
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                        <div className={"row"}>
                            <p className="fs-16px ibl-font-w-600 font-color-general-950 pb-2">
                                {t('zones')}
                            </p>

                            <div ref={zonesCardRef} className={'card-border-8px border-full-shades-300 d-flex flex-column'}>
                                <CustomTreeView
                                    key={'WorkShiftTreeView'}
                                    onInputchange={handleCheck}
                                    isChecked={item.checkedZones}
                                    checked={item.checkedZones}
                                    setChecked={setChecked}
                                    className={'flex-grow-1'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
                        <div className={"row"}>
                            <p className="fs-16px ibl-font-w-600 font-color-general-950 pb-2">
                                {t('active_schedule')}
                            </p>

                            <div ref={activeScheduleRef} className={'active-schedule card-border-8px border-full-shades-300'}>
                                <div className="row">
                                    <div className="col-12 px-0 pl-2 mb-3">
                                        <CustomCheckbox
                                            id={'cb_cs_de_select_all_days'}
                                            trans="all_days"
                                            checked={item.dayArray?.length === 7}
                                            onChange={selectAllDays}
                                            marginbutton={true}
                                        />
                                    </div>

                                    <div className="col-12 overflow-auto">
                                        <CustomDaySelector
                                            required
                                            emptyFields={emptyFields}
                                            dayArray={item.dayArray}
                                            setDayArray={setDayArray}
                                            containerClasses={'no-width'}
                                        />
                                    </div>

                                    {/* ALL TIME */}
                                    <div className="col-12 px-0 pl-2 mt-3">
                                        <CustomCheckbox
                                            id={'cb_cs_de_select_all_time'}
                                            trans={t('all_time')}
                                            name={'allTime'}
                                            checked={item.allTime}
                                            onChange={(e) => handleAllTime(e)}
                                            marginbutton={true}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex flex-column">
                                            <div className="w-100">
                                                <CustomTimePicker
                                                    title={t('from')}
                                                    name="fromTime"
                                                    value={item.fromValue}
                                                    handleChange={(newValue) => {
                                                        setItem((prev) => ({ ...prev, fromValue: newValue }));
                                                    }}
                                                    disabled={item.allTime}
                                                    ampm={false}
                                                    inputFormat="HH:mm:ss"
                                                    required
                                                    id={'txt_cs_from_time'}
                                                    actions={['accept', 'cancel']}
                                                    emptyFields={emptyFields}
                                                    formatValue={false}
                                                    maxDate={item.toValue ? new Date(item.toValue) : undefined}
                                                />
                                            </div>

                                            <div className="w-100">
                                                <CustomTimePicker
                                                    title={t('to')}
                                                    name="toTime"
                                                    value={item.toValue}
                                                    handleChange={(newValue) => {
                                                        setItem((prev) => ({ ...prev, toValue: newValue }));
                                                    }}
                                                    disabled={item.allTime}
                                                    ampm={false}
                                                    inputFormat="HH:mm:ss"
                                                    required
                                                    id={'txt_cs_to_time'}
                                                    actions={['accept', 'cancel']}
                                                    emptyFields={emptyFields}
                                                    formatValue={false}
                                                    isValid={isValidTo}
                                                    isValidText={'this_cant_have_at_least_time_to_from_or_same_time'}
                                                    helperText={t('this_cant_have_at_least_time_to_from_or_same_time')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4 d-flex justify-content-end">
                    <div className="col-4 d-flex justify-content-end">
                        <ButtonAction
                            id="btn_cs_add_items"
                            name={'add'}
                            className="btn-icon-upload-file"
                            Icon={UpdateIconsOptions}
                            splitName={false}
                            onClick={(e) => handleCLick(e)}
                        />
                    </div>
                </div>

                {customizedListAux?.length > 0 && (
                    <>
                        <div className="col-12">
                            <CustomizedItem
                                t={t}
                                title={'preview'}
                                list={customizedListAux.slice(0, 5)}
                                setList={setCustomizedListAux}
                                showNoInformation={false}
                                showCard={true}
                                onDelete={handleRemoveAccess}
                            />
                        </div>

                        {customizedListAux?.length >= 5 && (
                            <div className="d-flex justify-content-end pt-2">
                                <ButtonActionsCard
                                    id="btn_cs_show_full_schedules"
                                    name="show_full_schedules"
                                    iconProps="btn-icon-svg-12px icon-color-general-950"
                                    Icon={ArrowRightIcon}
                                    onClick={() => setShowModal(true)}
                                />
                            </div>
                        )}

                        <div className="col-12 d-flex justify-content-end pt-4 pb-3 pb-sm-0">
                            <ButtonAction
                                id="btn_cs_add_custom_shift"
                                name="add_custom_shift"
                                className="btn-outlined-secondary-600-25"
                                Icon={PlusIconsOptions}
                                splitName={false}
                                disabled={false}
                                onClick={() => {
                                    let list = handleAdded();
                                    setCustomizedList([...customizedList, ...list]);
                                    setCustomizedListAux([]);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>

            {showModal &&
                <CustomWorkShifts
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    list={customizedListAux}
                    setList={setCustomizedListAux}
                    onDelete={handleRemoveAccess}
                />
            }
        </>
    );
};

export default CustomizedSchedule;
